import * as Ladda from 'ladda';

export default () => {
    if(document.querySelector('.start-page, .archive-page, .more-posts') !== null && document.querySelector('#loadmore') !== null) {
        if(horizon.currentLang == "en"){
            var nomoreTxt = "No more articles to show";
        } else {
            var nomoreTxt = "Inga fler artiklar att visa";
        }
        const postContainer = document.querySelector('.posts');
        const loadmoreBtn = document.querySelector('#loadmore');
        var type = document.querySelector('#content_type').value;
        const postCount = document.getElementsByClassName('posts__post').length;
        const increment = 4; // Ladda x åt gången

        var l = Ladda.create( loadmoreBtn );


        let dataLM = { //data load more
            action: 'nobox_load_more_posts',
            offset: postCount-increment,
            archive: window.location.href,
            type: type,
            inc: increment,
            card: 0,
        };
        var loadMore = function(e) {
            loadmoreBtn.removeEventListener('click', loadMore);
            dataLM = {
                action: 'nobox_load_more_posts',
                offset: dataLM.offset,
                archive: window.location.href,
                type: type,
                inc: dataLM.inc,
                card: dataLM.card,
            };
            l.start();
            dataLM.offset += increment;
            dataLM.card++;

            $.post(
                horizon.ajaxUrl,
                dataLM,
                (data, response) => {
                    if (response === 'success') {
                        if (data.result.length > 0) {
                            data.result.forEach((post) => {
                                postContainer.innerHTML += post;
                            });
                            loadmoreBtn.addEventListener('click', loadMore);
                            addVideoClicks();
                        } else {
                            dataLM.offset -= increment;
                            loadmoreBtn.innerHTML = nomoreTxt;
                            loadmoreBtn.classList.add("empty");
                            loadmoreBtn.removeEventListener('click', loadMore);
                        }
                        l.stop();
                    }
                }
            );
        };
        loadmoreBtn.addEventListener('click', loadMore);
    }
};

function addVideoClicks(){
    if($('.posts__post').find('.video').length > 0) {
        $('.posts__post').find('.video').each(function() {
            $(this).click(function(){
                $(this).addClass('play');
            });
        });
    }
}
